import { keepPreviousData, useQuery } from '@tanstack/react-query';
import type { BookGenre } from '@booknest/shared';

import { libraryApi } from '../api/library.api.js';

const AUTOCOMPLETE_LIMIT = 10;

export function useBookSearch(q: string, genre?: BookGenre) {
  const trimmed = q.trim();
  return useQuery({
    queryKey: ['books', 'search', trimmed, AUTOCOMPLETE_LIMIT, genre ?? 'all'],
    queryFn: () =>
      libraryApi.searchBooks(trimmed, AUTOCOMPLETE_LIMIT, 0, genre),
    enabled: trimmed.length >= 2,
    staleTime: 5 * 60 * 1000,
    placeholderData: keepPreviousData,
  });
}
